import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=4f6fe4c2&class=true&"
import script from "./Footer.vue?vue&type=script&lang=js&"
export * from "./Footer.vue?vue&type=script&lang=js&"
import style0 from "./Footer.vue?vue&type=style&index=0&id=4f6fe4c2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UIOpeningTimes: require('/opt/build/repo/components/UI/OpeningTimes.vue').default,UITrustpilotWidget: require('/opt/build/repo/components/UI/TrustpilotWidget.vue').default,CartAddedToCartModal: require('/opt/build/repo/components/Cart/AddedToCartModal.vue').default,UISearch: require('/opt/build/repo/components/UI/Search.vue').default})
